const citiesAndUnits = {
  'Rio de Janeiro': [489],
  'Teresópolis': [562],
}

export function selectUnitByCity () {
  const forms = document.querySelectorAll('.alpes-forms');
  forms.forEach(form => {
    const citySelect = form.querySelectorAll('.form-input[name="cidades"]');
    const unitSelect = form.querySelector('.form-input[name="unit"]');
    const unitSelectOptions = form.querySelectorAll('.form-input[name="unit"] option');

    citySelect.forEach((item) => {
      item.addEventListener('blur', () => {
        unitSelect.value = "";
        showUnits(item.value, unitSelectOptions);
      })
    })

  })
}

function showUnits(city, units) {
  units.forEach(unit => {
    if (!city || !citiesAndUnits[city].includes(+unit.value)) {
      unit.setAttribute('hidden', true);
      unit.setAttribute('disabled', true);
    }
    else {
      unit.removeAttribute('hidden')
      unit.removeAttribute('disabled', true);
    }
  })
}